import {
  ErrorMessageEn,
  ErrorMessageEs,
  SuccessMessageEn,
  SuccessMessageEs,
} from '../../../../constants/alerts';
import { errorHandler, successHandler } from '../../../utils';
import {
  CompanyBuilder,
  UpdateCompanyInput,
  UpdateCompanyOutput,
} from '../companies.types';

export const updateCompany = (builder: CompanyBuilder) =>
  builder.mutation<UpdateCompanyOutput, UpdateCompanyInput>({
    query: ({
      companyId,
      Name,
      Description,
      OrganizationSize,
      Url,
      formData,
    }) => {
      // If formData is provided, use it (for file uploads)
      if (formData) {
        return {
          url: `/companies/${companyId}`,
          method: 'PUT',
          body: formData,
          formData: true,
        };
      }

      return {
        url: `/companies/${companyId}`,
        method: 'PUT',
        body: {
          Name,
          ...(Description && { Description }),
          ...(OrganizationSize && { OrganizationSize }),
          ...(Url && { Url }),
        },
      };
    },
    transformResponse: (queryResponse: UpdateCompanyOutput, _, arg) => {
      successHandler(
        arg.lang === 'es'
          ? SuccessMessageEs.COMPANY_UPDATE
          : SuccessMessageEn.COMPANY_UPDATE,
        true
      );
      return queryResponse;
    },
    transformErrorResponse: (error, meta, args) => {
      errorHandler(
        '[updateCompany]',
        args.lang === 'en'
          ? ErrorMessageEn.UpdateCompany
          : ErrorMessageEs.UpdateCompany,
        error,
        true
      );
      return error.data;
    },
    invalidatesTags: () => [{ type: 'Company' }],
  });
